module.exports = __webpack_public_path__ + "static/media/sildenafil.9d3851e0.jpg";